import { createAsyncThunk } from '@reduxjs/toolkit';
import { PlaidApi, ValidateIdentityParams, SetBankAccountsError } from 'api/PlaidApi';

export const createValidateIdentityThunk = (api: PlaidApi) =>
  createAsyncThunk('plaid/validateIdentity', async (payload: ValidateIdentityParams, thunkApi) => {
    try {
      return await api.validateIdentity(payload);
    } catch (error: any) {
      return thunkApi.rejectWithValue({ status: error.responseStatus, ...error.data } as SetBankAccountsError);
    }
  });

export default createValidateIdentityThunk;
